import React from 'react';
import { FaRobot, FaMagic } from 'react-icons/fa';

export default function AISummaryBox({ summary, isLoading }) {
  if (!summary && !isLoading) return null;

  return (
    <div className="ai-summary-box shadow-sm">
      <div className="ai-summary-header">
        <FaRobot size={20} />
        <span>AI Thread Summary</span>
        <FaMagic className="ai-sparkle ms-auto" size={14} />
      </div>
      
      <div className="ai-summary-content text-light">
        {isLoading ? (
          <div className="d-flex align-items-center gap-2 text-muted">
            <div className="spinner-grow spinner-grow-sm text-warning" role="status"></div>
            <span>Generating summary from latest replies...</span>
          </div>
        ) : (
          <p className="mb-0" style={{ lineHeight: '1.6' }}>
            {summary}
          </p>
        )}
      </div>
    </div>
  );
}
